export default {
  documento: state => state.documento
};
